/* eslint-disable no-magic-numbers */
import { useContext } from 'react'
import { MySiteContext } from 'providers/mySiteProvider'

export const usePersistPagination = () => {
  const { pagination, setDefaultPaginationState } = useContext(MySiteContext)

  function selectPage(currentPage) {
    setDefaultPaginationState((s) => {
      return { ...s, currentPage }
    })
  }

  function nextPage() {
    if (pagination.currentPage === pagination.totalPages) {
      return
    }
    setDefaultPaginationState((s) => {
      return { ...s, currentPage: s.currentPage + 1 }
    })
  }

  function prevPage() {
    if (pagination.currentPage === 1) {
      return
    }

    setDefaultPaginationState((s) => {
      return { ...s, currentPage: s.currentPage - 1 }
    })
  }

  function nextSection() {
    if (pagination.currentPage < 4) {
      setDefaultPaginationState((s) => {
        return { ...s, currentPage: 6 }
      })

      return
    }

    setDefaultPaginationState((s) => {
      return { ...s, currentPage: s.currentPage + 2 }
    })
  }

  function prevSection() {
    if (pagination.currentPage > pagination.totalPages - 4) {
      setDefaultPaginationState((s) => {
        return { ...s, currentPage: s.totalPages - 5 }
      })
      return
    }

    setDefaultPaginationState((s) => {
      return { ...s, currentPage: s.currentPage - 2 }
    })
  }

  const changeResultsPerPage = (e) => {
    setDefaultPaginationState((s) => {
      return { ...s, resultsPerPage: e.value, currentPage: 1 }
    })
  }

  const setPagination = (data) => {
    setDefaultPaginationState(data)
  }

  return { setPagination, selectPage, nextPage, prevPage, nextSection, prevSection, changeResultsPerPage }
}


